import pageContext from 'salvo-lite/context'

import Slider from './components/Slider'
import Slide from './components/Slide'
import ChangeClass from './components/ChangeClass'
import ChangeAttr from './components/ChangeAttr'
import Sticky from './components/Sticky'
import Select from './components/Select'
import Filter from './components/Filter'
import Thumbnails from './components/Thumbnails'
import Enable from './components/Enable'
import Clinics from './components/Clinics'
import CartUpdate from './components/CartUpdate'
// import ScrollHide from './components/ScrollHide'
import MobileMenuParent from './components/MobileMenuParent'
import MailingList from './components/MailingList'
import Megamenu from './components/Megamenu'
import Variants from './components/Variants'
import Accordion from './components/Accordion'
import Exponea from './components/Exponea'
import Validate from './components/Validate'
import Fadein from './components/Fadein'
import ScrollTo from './components/ScrollTo'
import ClinicPage from './components/ClinicPage'
import VariantImage from './components/VariantImage'
import BiomarkerWidget from './components/BiomarkerWidget'
import ReadMore from './components/ReadMore'
import SpotlightNav from './components/SpotlightNav'
import ReturnClear from './components/ReturnClear'

const components = {
    'slider': Slider,
    'slide': Slide,
    'change-class': ChangeClass,
    'change-attr': ChangeAttr,
    'sticky': Sticky,
    'select': Select,
    'filter': Filter,
    'thumbnail': Thumbnails,
    'enable': Enable,
    'clinics': Clinics,
    'cart-update': CartUpdate,
    // 'scroll-hide': ScrollHide,
    'mobile-menu-parent': MobileMenuParent,
    'mailing-list': MailingList,
    'megamenu': Megamenu,
    'variants': Variants,
    'accordion': Accordion,
    'exponea': Exponea,
    'validate': Validate,
    'fadein': Fadein,
    'scroll-to': ScrollTo,
    'clinic-page': ClinicPage,
    'variant-image': VariantImage,
    'biomarker-widget': BiomarkerWidget,
    'read-more': ReadMore,
    'spotlight-nav': SpotlightNav,
    'return-clear': ReturnClear
}

const pages = {
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js